import { Component, computed, effect, inject, input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { SmartInputEntityComponent } from '../smart-input-entity/smart-input-entity.component';
import { WorkPackageTypePickerHandler } from '../smart-input-entity/wp-type-picker.handler';
import { BaseFeatureDto, WorkPackageTypeDto } from '@api/backend-connector/models';
import { WPTypeBadgeComponent } from 'src/app/components/wp-card/wp-type-badge/wp-type-badge.component';
import { TemplateDirective } from 'src/app/directives/template.directive';
import { WorkPackageTypesService } from 'src/app/services/work-package-type.service';
import { cast } from 'src/app/utils';

export type WPTypePickable = Pick<WorkPackageTypeDto, 'id' | 'name' | 'color' | 'icon'> | BaseFeatureDto;

@Component({
  selector: 'app-wp-type-picker',
  templateUrl: './wp-type-picker.component.html',
  styleUrl: './wp-type-picker.component.scss',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TemplateDirective,
    TranslateModule,
    WPTypeBadgeComponent,
    SmartInputEntityComponent,
  ],
})
export class WPTypePickerComponent {
  private readonly workPackageTypesService = inject(WorkPackageTypesService);

  readonly control = input.required<FormControl<WPTypePickable | null | undefined>>();
  readonly placeholder = input('');
  readonly resetValue = input<WPTypePickable | undefined>(undefined);
  readonly excludeIds = input<string[] | null>();
  readonly projectOptions = input<WorkPackageTypeDto[]>();

  readonly workPackagePickerHandler = computed(() => {
    void this.resetValue();
    return new WorkPackageTypePickerHandler(this.workPackageTypesService, { projectOptions: this.projectOptions() });
  });

  readonly cast = cast<WPTypePickable>;

  constructor() {
    effect(() => {
      this.workPackagePickerHandler().setExcludeIds(this.excludeIds() ?? []);
    });
  }
}
